export default "__VITE_ASSET__d79a13be__"